import { render, staticRenderFns } from "./AuthHeroSkeleton.vue?vue&type=template&id=6ddfedda"
import script from "./AuthHeroSkeleton.vue?vue&type=script&lang=js"
export * from "./AuthHeroSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AuthHeroSkeleton.vue?vue&type=style&index=0&id=6ddfedda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports